import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { SiteActionCreators } from "../../store/actions/site";

import Loading from "../common/Loading";

const Business = () => {
  const dispatch = useDispatch();
  const sites = useSelector((state) => state?.site?.sites);
  const navigate = useNavigate();
  const selectedSite = useSelector((state) => state?.site?.selectedSite);
  const integrationType = useSelector(
    (state) => state.auth.user.integrationType
  );

  if (integrationType !== 5) return null;

  useEffect(() => {
    dispatch(SiteActionCreators.getSites()).then((res) => {
      if (!res.data?.length) {
        navigate(`/sites/add`);
        return;
      }
      const siteId =
        selectedSite === null || (!selectedSite?.id && !selectedSite?.virgulId)
          ? res?.data?.length > 1
            ? res?.data[1]?.id
            : res?.data[0]?.id
          : selectedSite?.id ?? selectedSite?.virgulId;

      dispatch(SiteActionCreators.getSite(siteId)).then(() => {
        navigate(`/business/${siteId}`);
      });
    });
  }, [integrationType, dispatch, navigate, selectedSite]);

  if (!sites) {
    return <Loading />;
  }

  return null;
};

export default Business;
